/**
 * Tela 1 — Seu Nome  (instrumentada com logs de diagnóstico)
 */

import { useState, useEffect } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { getWelcomeText } from '../../../utils/welcomeText';
import { authService } from '../../../services/authService';
import { wlog } from '../../../utils/welcomeDebug';

export default function Step1Name({ wizard, goNext }) {
  const [name, setName] = useState(() => {
    let initial = '';
    try {
      initial = authService.getUserInfo()?.name || '';
    } catch (e) {
      wlog('Step1Name', '⚠️ getUserInfo() lançou erro', e?.message);
    }
    wlog('Step1Name', 'useState inicial name', initial);
    return initial;
  });

  const template = wizard.template;

  wlog('Step1Name', 'RENDER', {
    name,
    templateId: template?.id || 'NENHUM',
    temWelcomeNoTemplate: !!template?.welcome,
  });

  // Mount / unmount
  useEffect(() => {
    wlog('Step1Name', '🟢 MONTADO no DOM');
    return () => wlog('Step1Name', '🔴 DESMONTADO do DOM');
  }, []);

  let titleText = 'Pra começar, qual é o seu nome?';
  let hintText = '';
  try {
    titleText = getWelcomeText(template, 'userNameTitle', {}) || titleText;
    hintText = getWelcomeText(template, 'userNameHint', {});
  } catch (e) {
    wlog('Step1Name', '⚠️ getWelcomeText lançou erro', e?.message);
  }
  wlog('Step1Name', 'textos resolvidos', { titleText, hintText });

  const isFilled = name.trim().length > 0;

  const handleContinue = () => {
    wlog('Step1Name', 'handleContinue()', { name, isFilled });
    if (!isFilled) return;
    wizard.setUserName(name.trim());
    (goNext || wizard.goNext)();
  };

  return (
    <Box
      component="section"
      data-step="userName"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px 40px',
        minHeight: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ maxWidth: '500px', width: '100%', textAlign: 'center' }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontWeight: 600, marginBottom: '16px', color: 'text.primary' }}
        >
          {titleText}
        </Typography>

        <TextField
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Seu nome"
          variant="outlined"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && isFilled) handleContinue();
          }}
          sx={{
            marginBottom: hintText ? '20px' : '32px',
            '& .MuiOutlinedInput-root': { fontSize: '16px' },
          }}
        />

        {hintText && (
          <Typography
            sx={{
              fontSize: '13px',
              color: 'text.secondary',
              marginBottom: '40px',
              lineHeight: 1.6,
            }}
          >
            {hintText}
          </Typography>
        )}

        <Button
          variant="contained"
          size="large"
          onClick={handleContinue}
          disabled={!isFilled}
          sx={{
            textTransform: 'none',
            fontSize: '16px',
            fontWeight: 600,
            paddingX: '48px',
            paddingY: '12px',
          }}
        >
          Continuar
        </Button>
      </Box>
    </Box>
  );
}
